module.exports = __webpack_public_path__ + "img/ckdirect.ec967dd0.png";